export default __webpack_public_path__ + "static/media/img (3).23398843.jpg";